import React from 'react';
import PropTypes from 'prop-types';

const whitespace = /\s/g;

function lower(string) {
  return string.toLowerCase();
}

function slugger(str, maintainCase) {
  let string = str;
  const re = /[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g;
  const replacement = '-';

  if (typeof string !== 'string') return '';
  if (!maintainCase) string = string.replace(/[A-Z]+/g, lower);
  return string
    .trim()
    .replace(re, '')
    // .replace(emoji(), '')
    .replace(whitespace, replacement)
    // remove ® (added by Chris Boon)
    .replace('®', '');
}

const PageToc = (props) => {
  const { headings } = props;

  return (
    <div className="doc-page-toc">
      <ul className="doc-page-toc-ul">
        {headings.map((item) => {
          const { depth, value } = item;
          const concatValue = slugger(value);

          return (
            <li key={concatValue}>
              <a
                className={`doc-page-toc-link doc-page-toc-link-level-${depth}`}
                href={`#${concatValue}`}
              >
                {value}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
PageToc.propTypes = {
  headings: PropTypes.arrayOf(PropTypes.shape({
    depth: PropTypes.number.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
};

export default PageToc;



// WEBPACK FOOTER //
// ./src/components/PageToc/PageToc.js